import React, { useEffect } from "react";
import { UserPlus } from "lucide-react";
import { useSponsorshipStore } from "@/stores/sponsorship/sponsorship-store";

export const PendingSponsorshipsBadge: React.FC = () => {
  const pendingCount = useSponsorshipStore((state) => state.pendingCount);
  const fetchAll = useSponsorshipStore((state) => state.fetchAll);

  useEffect(() => {
    void fetchAll();
  }, [fetchAll]);

  return (
    <span className="relative inline-flex">
      <UserPlus className="h-5 w-5" />
      {pendingCount > 0 ? (
        <span className="absolute -right-2 -top-2 rounded-full bg-destructive px-1.5 text-[10px] font-medium text-destructive-foreground">
          {pendingCount}
        </span>
      ) : null}
    </span>
  );
};
